<script>
import appConfig from "@/app.config";

export default {
  page: {
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {},
  data() {
    return {
      neighborhoods: [],
      tariffs: [],
      page: 1,
      limit: 20,
      tot_pages: 0,
      searchModel: null,
      searchMode: false,
      // appprices:[]
    };
  },
  methods: {
    addNeighborhoods() {
      var data = {
        title: "popups.add",
        inputs: [
          {
            model: "name",
            type: "text",
            label: "popups.name",
            restrictions: { required: true },
          },
          {
            model: "area_code",
            type: "text",
            label: "neighborhoods.area_code",
            restrictions: { required: true },
          },
          {
            model: "name_en",
            type: "text",
            label: "popups.name_en",
            restrictions: { required: true },
          },
        ],
        buttons: [
          {
            text: "popups.add",
            closer: true,
            validate: true,
            color: "primary",
            handler: (obj) => {
              this.http.post("neighborhoods", obj).then(() => {
                this.get(this.page);
              });
            },
          },
          {
            text: "popups.cancel",
            closer: true,
            color: "danger",
            handler: () => {
              console.log("Like Clicked");
            },
          },
        ],
      };
      this.popup.modal(data);
    },
    search(page) {
      if (!this.searchModel.length) return this.cancelSearchMode();
      this.searchMode = true;
      this.http
        .post("neighborhoods/search", {
          search: this.searchModel,
          limit: this.limit,
          page: this.page,
          col: "name",
        })
        .then((res) => {
          this.page = page;
          this.tot_pages = Math.ceil(res.tot / this.limit);
          this.neighborhoods = res.data;
        });
    },
    cancelSearchMode() {
      this.searchModel = "";
      this.searchMode = false;
      this.get(this.page);
    },
    deleteNeighborhoods(neighborhood) {
      var data = {
        title: "popups.delete",
        msg: "popups.deletemsg",
      };
      this.popup.confirm(data).then((res) => {
        if (res) {
          this.http.delete("neighborhoods", neighborhood.id).then(() => {
            this.get(this.page);
          });
        }
      });
    },
    editNeighborhoods(neighborhood) {
      var data = {
        title: "popups.edit",
        inputs: [
          {
            model: "name",
            type: "text",
            label: "popups.name",
            value: neighborhood.name,
            restrictions: { required: true },
          },
          {
            model: "area_code",
            type: "text",
            label: "neighborhoods.area_code",
            value: neighborhood.area_code,
            restrictions: { required: true },
          },
          {
            model: "name_en",
            type: "text",
            label: "popups.name_en",
            value: neighborhood.name_en,
            restrictions: { required: true },
          },
        ],
        buttons: [
          {
            text: "popups.edit",
            closer: true,
            validate: true,
            color: "primary",
            handler: (obj) => {
              this.http.put("neighborhoods", neighborhood.id, obj).then(() => {
                this.get(this.page);
              });
            },
          },
          {
            text: "popups.cancel",
            closer: true,
            color: "danger",
            handler: () => {
              console.log("Like Clicked");
            },
          },
        ],
      };
      this.popup.modal(data);
    },

    get(page) {
      console.log(page);
      this.http
        .post("neighborhoods/pagination", {
          limit: this.limit,
          page: page,
        })
        .then((res) => {
          this.page = page;
          this.tot_pages = Math.ceil(res.tot / this.limit);
          this.neighborhoods = res.data;
        });
    },
  },
  created() {
    this.get(1);
  },
};
</script>

<template>
  <div class="row">
    <div class="card">
      <div class="card-body">
        <div class="row">
          <div class="col-6">
            <div class="search-box chat-search-box" style="width: 250px">
              <div class="position-relative">
                <input
                  :dir="$i18n.locale == 'ar' ? 'rtl' : ''"
                  @input="search(page)"
                  type="search"
                  class="form-control fa-lg text-light"
                  :placeholder="$t('tariff.search')"
                  v-model="searchModel"
                  style="background-color: #2a3042 !important"
                />
                <i class="bx bx-search-alt search-icon text-light"></i>
              </div>
            </div>
          </div>
          <div class="col-6" style="display: flex; justify-content: flex-end">
            <button
              type="button"
              class="btn btn-light float-end mb-4"
              @click="addNeighborhoods()"
            >
              <span
                class="bx bxs-plus-circle float-end fa-2x"
                style="color: #2a3042 !important"
              ></span>
            </button>
          </div>
        </div>
        <div class="table-responsive">
          <table
            class="table table-striped table-hover mb-0"
            :dir="$i18n.locale == 'ar' ? 'rtl' : ''"
          >
            <thead>
              <tr
                class="text-light"
                style="background-color: #2a3042 !important"
              >
                <th scope="col">#</th>
                <th scope="col">{{ $t("neighborhoods.name") }}</th>
                <th scope="col">{{ $t("neighborhoods.area_code") }}</th>
                <th scope="col">{{ $t("neighborhoods.created") }}</th>
                <th scope="col">{{ $t("neighborhoods.updated") }}</th>
                <th scope="col">{{ $t("neighborhoods.operations") }}</th>
              </tr>
            </thead>
            <tbody>
              <tr
                class=""
                v-for="(neighborhood, index) in neighborhoods"
                :key="neighborhood"
              >
                <td>{{ (page - 1) * this.limit + index + 1 }}</td>
                <td>
                  {{
                    $i18n.locale == "ar"
                      ? neighborhood.name
                      : neighborhood.name_en
                      ? neighborhood.name_en
                      : neighborhood.name
                  }}
                </td>
                <td>{{ neighborhood?.area_code }}</td>
                <td>{{ neighborhood?.created.split("T")[0] }}</td>
                <td>{{ neighborhood?.updated.split("T")[0] }}</td>
                <td>
                  <button
                    type="button"
                    class="btn btn-primary me-2 btn-sm"
                    @click="editNeighborhoods(neighborhood)"
                  >
                    {{ $t("popups.edit") }}
                  </button>
                  <a
                    class="btn btn-danger btn-sm me-2"
                    href="javascript:void(0)"
                    role="button"
                    @click="deleteNeighborhoods(neighborhood)"
                    >{{ $t("popups.delete") }}</a
                  >
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
  <!-- end  table -->
  <!-- Button trigger modal -->

  <!--   Apps  Pagination     -->
  <ul class="pagination pagination-rounded justify-content-center mb-2">
    <li class="page-item" :class="{ disabled: page == 1 }">
      <a
        class="page-link"
        href="javascript: void(0);"
        @click="searchModel ? search(page - 1) : get(page - 1)"
        aria-label="Previous"
      >
        <i class="mdi mdi-chevron-left"></i>
      </a>
    </li>
    <li
      class="page-item"
      :class="{ active: p == page }"
      v-for="p in tot_pages"
      :key="p"
    >
      <a
        class="page-link"
        href="javascript: void(0);"
        @click="searchModel ? search(p) : get(p)"
        >{{ p }}</a
      >
    </li>

    <li class="page-item" :class="{ disabled: page == tot_pages }">
      <a
        class="page-link"
        href="javascript: void(0);"
        @click="searchModel ? search(page + 1) : get(page + 1)"
        aria-label="Next"
      >
        <i class="mdi mdi-chevron-right"></i>
      </a>
    </li>
  </ul>
  <!--end-->
</template>
